var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('secgroup-list',{attrs:{"hiddenActions":['openSecgroupSidepageTab'],"hiddenColumns":['guest_cnt'],"hiddenSidepageTabs":['vminstance-list'],"id":_vm.id,"getParams":_vm.getParams,"show-create-action":false}})}
var staticRenderFns = []

export { render, staticRenderFns }